module.exports = __webpack_public_path__ + "img/ceo-1.e80b46d.webp";